<template>
  <div class="w-full h-full">
    <el-row class="flex mb-5px w-full">
      <div class="flex items-center">
        <el-button
          type="primary"
          size="mini"
          class="mr-10px iconfont icon-line-return"
          @click="goBack"
          >返回</el-button
        >
        <p class="pl-10px title-left-border-back border-l-2px text-16px">模板编辑</p>
      </div>
    </el-row>

    <div id="gc-designer-container-box" v-loading="spreadjsLoading" ref="gcBox"></div>
    <ScopeOfDistribution
      @close="closeScope"
      :visible="scopeDistuibutionVisible"
      v-if="scopeDistuibutionVisible"
    />

    <!-- 字段选择弹窗 start -->
    <StorageDialog
      v-if="showStorageDialog"
      :visible.sync="showStorageDialog"
      :treeListData="selectedEntityList"
      :selectedList="selectedFieldList"
      @getSelectedList="getSelectedList"
    ></StorageDialog>
    <!-- 字段选择弹窗 end -->

    <!-- 模式切换弹窗 start -->
    <ModeChange
      v-if="showModeDialog"
      :visible.sync="showModeDialog"
      :modeType="modeType"
      @modeChange="modeChange"
    ></ModeChange>
    <!-- 模式切换弹窗 end -->

    <!-- 字段绑定 start -->
    <SelecteTable
      v-if="showSelecteTableDialog"
      :visible.sync="showSelecteTableDialog"
      :treeListData="tableFieldList"
      :isSingleChoice="true"
      @getSelectedList="setTableBinding"
    ></SelecteTable>
    <!-- 字段绑定 end -->
  </div>
</template>

<script>
import StandardManagementService from '@/services/common/StandardManagementService'
import dayjs from 'dayjs'
import ScopeOfDistribution from './scopeOfDistribution'

const StorageDialog = () => {
  return import('./components/storageDialog')
}
const ModeChange = () => {
  return import('./components/modeChange')
}
const SelecteTable = () => {
  return import('./components/selecteTable')
}

export default {
  created() {
    // 避免重写方法的时候重写了已保存的原方法
    const pathObj = {
      oldSetBindingPathFun: GC.Spread.Sheets.CellRange.prototype.bindingPath,
    }
    const copyPathObj = _.cloneDeep(pathObj)
    this.oldSetBindingPathFun = copyPathObj.oldSetBindingPathFun
  },
  async mounted() {
    if (this.$route.query.type !== 'view') {
      await this.getEntityTree()
    }
    this.initSheet()
  },
  beforeDestroy() {
    GC.Spread.Sheets.CellRange.prototype.bindingPath = this.oldSetBindingPathFun
  },
  deactivated() {
    GC.Spread.Sheets.CellRange.prototype.bindingPath = this.oldSetBindingPathFun
  },
  components: {
    ScopeOfDistribution,
    StorageDialog,
    ModeChange,
    SelecteTable,
  },
  watch: {
    isGragEnd(newValue) {
      if (newValue) {
        this.addFieldRuleByTable() // 表
      }
    },
    modeType: {
      handler(newValue) {
        if (newValue === 1) {
          this.resetBindingPathFun()
        } else {
          GC.Spread.Sheets.CellRange.prototype.bindingPath = this.oldSetBindingPathFun
        }
      },
    },
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  data() {
    return {
      scopeDistuibutionVisible: false,
      spread: null,
      excelIo: null,
      sheet: null,
      designer: null,
      tableFieldList: [], // 字段列表数据
      isGragEnd: false, // 是否已拖动结束
      showStorageDialog: false, // 是否显示多处存储弹窗
      fieldSameValue: {}, // 多个字段获取同一个单元格值信息
      currentSelectedInfo: {}, // 当前选中单元格的字段对应的表以及对应的字段信息
      selectedInfo: {}, // 所有选择过的字段信息
      defineParasList: [], // 需要实时请求接口的枚举规则
      currentFieldMode: '', // 当前打开字段选择弹窗的是哪个模式
      selectedEntityList: [], // 待选择的目录树字段数据
      selectedFieldList: [], // 已选择的目录树字段数据
      isSingleChoice: false, // 字段选择是否只能选一条数据
      spreadjsLoading: false, // 数据加载loading
      currentTable: null, // 当前激活的表格
      currentDropPosition: null, // 当前拖拽项定位信息
      showModeDialog: false, // 是否显示模式切换弹窗
      modeType: 1, // 模式绑定
      oldSetBindingPathFun: null, // 重写前的字段绑定方法
      showSelecteTableDialog: false, // 是否显示字段绑定弹窗
      currentSelectedCellTextList: [], // 当前选中的单元格文本信息
    }
  },
  methods: {
    /**
     * @description 模式切换
     * @param {Number} mode 1.表绑定 2.字段绑定
     */
    modeChange(mode) {
      this.modeType = mode
    },

    /**
     * @description 重写字段绑定方法
     */
    resetBindingPathFun() {
      const sheet = this.spread.getActiveSheet()
      GC.Spread.Sheets.CellRange.prototype.bindingPath = (text) => {
        if (this.currentDropPosition) {
          this.$nextTick(() => {
            const tableColumn = new GC.Spread.Sheets.Tables.TableColumn() // 表列
            tableColumn.name(text.split('.')[1])
            tableColumn.dataField(text.split('.')[1])
            const table = sheet.tables.add(
              // `${text.split('.')[0]}${new Date().getTime()}`,
              `gcTable${new Date().getTime()}`,
              this.currentDropPosition.row,
              this.currentDropPosition.col,
              2,
              1
            ) // 添加表格
            table.bindingPath(text.split('.')[0])
            table.autoGenerateColumns(false)
            table.bindColumns([tableColumn]) // 表格添加表列
            sheet.setActiveCell(this.currentDropPosition.row, this.currentDropPosition.col)
            this.currentDropPosition = null
          })
        }
      }
    },

    /**
     * @description 列宽自适应
     */
    async addFieldRuleByTable() {
      const spreadJson = this.spread.toJSON()
      const sheetsKeys = Object.keys(spreadJson.sheets)
      if (!sheetsKeys.length) return
      const sheet = this.spread.getActiveSheet()
      this.$nextTick(() => {
        // 列宽自适应
        this.spread.suspendPaint()
        const columnCount = spreadJson.sheets[sheetsKeys[0]]?.columnCount
        if (columnCount && sheet) {
          for (let i = 0; i < columnCount; i += 1) {
            sheet.autoFitColumn(i)
          }
        }
        // 行高自适应
        const rowTable = spreadJson.sheets[sheetsKeys[0]]?.data?.dataTable
        if (rowTable && sheet) {
          const rowCountList = Object.keys(rowTable)
          if (rowCountList) {
            const rowCount = rowCountList[rowCountList.length - 1]
            for (let i = 0; i < rowCount; i += 1) {
              sheet.autoFitRow(i)
            }
          }
        }
        this.spread.resumePaint()
      })
    },

    /**
     * @description 保存模板
     */
    async saveTemplate() {
      let res = null
      this.spreadjsLoading = true
      if (this.$route.query.templateId) {
        res = await StandardManagementService.updateTemplateData({
          name: this.$route.query.className,
          context: JSON.stringify(this.spread.toJSON()),
          multiple: true,
          anonymity: true,
          isValid: this.$route.query.isValid,
          classId: this.$route.query.classId,
          id: this.$route.query.templateId,
          isNeedApprove: this.$route.query.isNeedApprove,
          defineParas: JSON.stringify(this.defineParasList), // 需要实时请求接口的枚举规则
        })
      } else {
        res = await StandardManagementService.saveEntity({
          name: this.$route.query.className,
          context: JSON.stringify(this.spread.toJSON()),
          multiple: true,
          anonymity: true,
          isValid: this.$route.query.isValid,
          classId: this.$route.query.classId,
          defineParas: JSON.stringify(this.defineParasList), // 需要实时请求接口的枚举规则
        })
      }
      this.spreadjsLoading = false
      if (res && res.code === 0 && res.data) {
        this.$message.success('保存成功')
        const fieldSameValueKeys = Object.keys(this.fieldSameValue)
        if (!fieldSameValueKeys.length) return
        const list = []
        _.forEach(fieldSameValueKeys, (key) => {
          const resourceData = this.selectedInfo[key]
          const mappingList = this.fieldSameValue[key]
          _.forEach(mappingList, (item) => {
            list.push({
              resourceClassId: resourceData.classId,
              resourceAttributeId: resourceData.attributeId,
              mappingClassId: item.classId,
              mappingAttributeId: item.attributeId,
            })
          })
        })
        await StandardManagementService.saveAttributeMapping({
          templateId: this.$route.query.templateId || res.data.id,
          list,
        })
      }
    },

    /**
     * @description 获取实体属性树
     */
    async getEntityTree() {
      this.spreadjsLoading = true
      const res = await StandardManagementService.getEntityTree({
        standardId: this.$route.query.standardId,
      })
      if (res && res.data && res.code === 0) {
        this.tableFieldList = [...res.data]
        this.getAttributeMapping()
      }
      this.spreadjsLoading = false
    },

    /**
     * @description 获取多字段公用单元格数据信息
     */
    async getAttributeMapping() {
      if (!this.$route.query.templateId) return
      this.spreadjsLoading = true
      const res = await StandardManagementService.getAttributeMapping({
        templateId: this.$route.query.templateId,
      })
      this.spreadjsLoading = false
      if (res && res.data?.list && res.code === 0) {
        const mapList = [...res.data.list]
        _.forEach(mapList, (mapItem) => {
          // 拼装选中过的字段信息
          const selectedTable = _.find(this.tableFieldList, (fieldItem) => {
            return fieldItem.classId === mapItem.resourceClassId
          }) // 表
          if (selectedTable) {
            if (!this.selectedInfo[mapItem.resourceAttributeId]) {
              this.selectedInfo[mapItem.resourceAttributeId] = {
                bindingPath: selectedTable.className,
                classId: selectedTable.classId,
                attributeId: mapItem.resourceAttributeId,
              }
            }
          }

          // 拼装勾选的字段信息
          const checkedTable = _.find(this.tableFieldList, (fieldItem) => {
            return fieldItem.classId === mapItem.mappingClassId
          }) // 表
          if (checkedTable) {
            const attribute = _.find(checkedTable.attributeList, (attributeItem) => {
              return attributeItem.attributeId === mapItem.mappingAttributeId
            }) // 属性字段信息
            if (attribute) {
              if (this.fieldSameValue[mapItem.resourceAttributeId]) {
                this.fieldSameValue[mapItem.resourceAttributeId].push({
                  ...attribute,
                  classId: checkedTable.classId,
                  className: checkedTable.className,
                })
              } else {
                this.fieldSameValue[mapItem.resourceAttributeId] = [
                  {
                    ...attribute,
                    classId: checkedTable.classId,
                    className: checkedTable.className,
                  },
                ]
              }
            }
          }
        })
      }
    },

    /**
     * @description 获取当前选择获取同一个单元格值多个字段
     * @param {Array} selectedList 当前选择项
     */
    getSelectedList(selectedList) {
      // 当前选中字段所对应的所有取同一个单元格值的字段信息
      this.fieldSameValue[this.currentSelectedInfo.attributeId] = [...selectedList]
    },

    /**
     * @description 单元格绑定数据源
     * @param {Array} entityList 实体数据
     */
    setTableBinding(entityList) {
      if (!this.currentSelectedCellTextList.length) return
      const entity = entityList[0]
      const tableColumns = []
      let isFail = false
      _.forEach(this.currentSelectedCellTextList, (text) => {
        const attribute = _.find(entity.attributeList, (attributeItem) => {
          return attributeItem.attributeName === text
        })
        if (!attribute) {
          isFail = true
          this.$message.warning(`当前该表未存在${text}字段, 绑定失败`)
          return
        }
        const tableColumn = new GC.Spread.Sheets.Tables.TableColumn() // 表列
        tableColumn.name(attribute.attributeName)
        tableColumn.dataField(attribute.attributeName)
        tableColumns.push(tableColumn)
      })
      if (isFail) return
      const sheet = this.spread.getActiveSheet()
      const selectionCell = sheet.getSelections() // 当前选中项
      const table = sheet.tables.add(
        `gcTable${new Date().getTime()}`,
        selectionCell[0].row,
        selectionCell[0].col,
        2,
        tableColumns.length
      ) // 添加表格
      table.bindingPath(entity.className)
      table.autoGenerateColumns(false)
      table.bindColumns([...tableColumns]) // 表格添加表列
    },

    /**
     * @description 单元格绑定数据源
     * @param {Array} cellList 需绑定单元格的数据源
     */
    cellBindDataSource(cellList) {
      const sheet = this.spread.getActiveSheet()
      const selectionCell = sheet.getSelections() // 当前选中项
      let table = this.currentTable
        ? sheet.tables.findByName(this.currentTable.name)
        : sheet.tables.findByName(cellList[0].className) // 查询当前是否存在已新建的表格
      const cellRow = selectionCell[0].row // 当前选中项行
      const cellCol = selectionCell[0].col // 当前选中项列
      if (!table) {
        table = sheet.tables.add(cellList[0].className, cellRow, cellCol, 2, 1) // 添加表格
        table.bindingPath(cellList[0].className)
        table.autoGenerateColumns(false)
        const tableColumn = new GC.Spread.Sheets.Tables.TableColumn() // 表列
        tableColumn.name(cellList[0].attributeName)
        tableColumn.dataField(cellList[0].attributeName)
        table.bindColumns([tableColumn]) // 表格添加表列
        return
      }
      const entityClass = _.find(this.tableFieldList, (tableFile) => {
        return cellList[0].className === tableFile.className
      }) // 对应实体项
      if (!entityClass) return

      const tableColumnNames = [...table.getSlicerData().columnNames] // 表格中对应的表头名称
      if (!tableColumnNames.length) return

      const addTableColumns = [] // 需绑定字段(包含表原来已绑定的字段)
      _.forEach(tableColumnNames, (columnName) => {
        const tableColumn = new GC.Spread.Sheets.Tables.TableColumn() // 表列
        tableColumn.name(columnName)
        tableColumn.dataField(columnName)
        addTableColumns.push(tableColumn)
      })
      table.bindColumns([...addTableColumns]) // 表格添加表列
    },

    /**
     * @description 获取到当前选中单元格的字段对应的表以及对应的字段
     */
    getCurrentField() {
      this.currentTable = null
      const spreadJSON = this.spread.toJSON()
      const sheet = Object.values(spreadJSON.sheets)[0] // 当前已存在的表
      if (!sheet) {
        this.$message.warning('请先添加工作表')
        return
      }
      const tables = sheet.tables
      if (!tables.length) {
        this.$message.warning('请先添加列表')
        return
      }
      const activeSheet = this.spread.getActiveSheet()
      const selectionCell = activeSheet.getSelections() // 当前选中项
      if (!selectionCell.length) {
        this.$message.warning('请先选中字段')
        return
      }

      const row = selectionCell[0].row // 行
      const col = selectionCell[0].col // 列
      const cellValue = activeSheet.getValue(row, col)

      if (!cellValue && this.currentFieldMode !== 'binding') {
        // 当前单元格拖拽的是单个字段
        const dataTable = sheet.data.dataTable
        const tableValue = dataTable[`${row}`][`${col}`].bindingPath
        if (tableValue) {
          const [tableName, fieldName] = tableValue.split('.')
          if (tableName && fieldName) {
            const table = _.find(this.tableFieldList, (tableItem) => {
              return tableItem.className === tableName
            })
            if (table) {
              const attribute = _.find(table.attributeList, (attributeItem) => {
                return attributeItem.attributeName === fieldName
              })
              if (attribute) {
                this.currentSelectedInfo = {
                  bindingPath: tableName,
                  classId: table.classId,
                  attributeId: attribute.attributeId,
                }
                this.selectedInfo[attribute.attributeId] = { ...this.currentSelectedInfo }
                this.showStorageDialog = true
              }
            }
            return
          }
        }
      }
      // 当前单元格是拖拽表中的某个字段
      const table = _.find(tables, (item) => {
        return item.row === row && col >= item.col && col < item.col + item.colCount
      }) // 当前选中项所属表
      if (this.currentFieldMode === 'binding' && cellValue) {
        if (table) {
          this.currentTable = { ...table }
          // 当前部分已建立表
          const entityList = _.find(this.tableFieldList, (item) => {
            return table.bindingPath === item.className
          }) // sheet中已拖拽的实体数据
          if (!entityList) {
            this.$message.warning('请选择已在表中的字段')
            return
          }
          this.selectedEntityList = [{ ...entityList }]

          // 从table中去查找当前字段(单元格)是否已绑定字段
          const column = _.find(table.columns, (item) => {
            return item.dataField === cellValue
          })
          if (column) {
            // 从实体中取出已绑定字段
            const attribute = _.find(entityList.attributeList, (item) => {
              return item.attributeName === cellValue
            }) // 字段对应的属性
            if (attribute) {
              this.selectedFieldList = [{ ...attribute, className: table.bindingPath }]
            } else {
              this.selectedFieldList = []
            }
          } else {
            this.selectedFieldList = []
          }
        } else {
          const entityList = _.filter(this.tableFieldList, (item) => {
            return _.find(tables, (tableItem) => {
              return tableItem.bindingPath === item.className
            })
          }) // sheet中已拖拽的实体数据
          if (!entityList.length) {
            this.$message.warning('请选择已在表中的字段')
            return
          }
          this.selectedEntityList = [...entityList]
          this.selectedFieldList = []
        }
        this.isSingleChoice = true
        this.showStorageDialog = true
        return
      }

      if (!table) {
        this.$message.warning('请选择已在表中的字段')
        return
      }

      const entity = _.find(this.tableFieldList, (item) => {
        return item.className === table.bindingPath
      }) // 表对应的实体
      if (!entity) {
        this.$message.warning('请选择已在表中的字段')
        return
      }

      const field = table.columns[col - table.col] // 当前选中项对应的字段
      const attribute = _.find(entity.attributeList, (item) => {
        return item.attributeName === field.name
      }) // 字段对应的属性
      if (!attribute) {
        this.$message.warning('请选择已在表中的字段')
        return
      }

      this.selectedEntityList = [...this.tableFieldList]
      this.isSingleChoice = false
      this.currentSelectedInfo = {
        bindingPath: table.bindingPath, // 表
        classId: entity.classId,
        attributeId: attribute.attributeId,
      }
      this.selectedInfo[attribute.attributeId] = { ...this.currentSelectedInfo }
      this.selectedFieldList = this.fieldSameValue[this.currentSelectedInfo.attributeId]
        ? [...this.fieldSameValue[this.currentSelectedInfo.attributeId]]
        : []
      this.showStorageDialog = true
    },

    /**
     * @description 打开字段绑定弹窗
     */
    getCurrentSelectedField() {
      const activeSheet = this.spread.getActiveSheet()
      const selectionCell = activeSheet.getSelections() // 当前选中项
      if (!selectionCell.length) {
        this.$message.warning('请先选中字段')
        return
      }
      const row = selectionCell[0].row // 选中部分行起始索引
      const col = selectionCell[0].col // 选中部分列起始索引
      // const cellValue = activeSheet.getValue(row, col)
      const fieldNameList = []
      const spreadJSON = this.spread.toJSON()
      const sheet = Object.values(spreadJSON.sheets)[0] // 当前已存在的表
      const tables = sheet.tables // 已初始化的表格

      for (let i = col; i < col + selectionCell[0].colCount; i += 1) {
        const cellValue = activeSheet.getValue(row, i)
        if (!cellValue) {
          this.$message.warning('所选区域请不要包含空白单元格')
          return
        }

        // 判断所选区域中表头中是否已有初始化好的表格
        const table = _.find(tables, (item) => {
          return item.row === row && col >= item.col && col < item.col + item.colCount
        }) // 当前选中项所属表
        if (table) {
          this.$message.warning('所选区域请不要包含已初始化好表格的单元格')
          return
        }
        fieldNameList.push(cellValue)
      }
      this.currentSelectedCellTextList = [...fieldNameList]
      this.showSelecteTableDialog = true
    },

    closeScope() {
      this.scopeDistuibutionVisible = false
    },

    formatData(arr) {
      const result = {}
      arr.forEach((item) => {
        const { className, attributeList } = item
        const properties = {}
        attributeList.forEach((field) => {
          const { attributeName, type, dataFieldType } = field
          properties[attributeName] = { type, dataFieldType }
        })
        result[className] = {
          properties,
          dataFieldType: 'table',
        }
      })
      return result
    },

    async initSheet() {
      const config = { ...GC.Spread.Sheets.Designer.DefaultConfig }
      // 创建自定义按钮
      config.commandMap = {
        export: {
          title: '自定义命令',
          text: '导出',
          bigButton: 'true',
          iconClass: 'iconfont icon-line-download',
          commandName: 'export',
          execute: () => {
            const json = this.spread.toJSON()
            this.excelIo.save(
              json,
              (blob) => {
                this.down(blob)
              },
              () => {}
            )
          },
        },
        edit: {
          title: '自定义命令',
          text: '编辑',
          bigButton: 'true',
          iconClass: 'iconfont icon-line-edit',
          commandName: 'edit',
          execute: () => {
            const sheet = this.spread.getActiveSheet()
            sheet.options.isProtected = false
          },
        },
        task: {
          title: '自定义命令',
          text: '下发任务',
          bigButton: 'true',
          iconClass: 'iconfont icon-line-files',
          commandName: 'task',
          execute: () => {
            this.scopeDistuibutionVisible = true
          },
        },
        saveTemplate: {
          title: '自定义命令',
          text: '保存模板',
          bigButton: 'true',
          iconClass: 'iconfont icon-bg-save',
          commandName: 'saveTemplate',
          execute: async () => {
            await this.saveTemplate()
          },
        },
        storage: {
          title: '自定义命令',
          text: '多处存储',
          bigButton: 'true',
          iconClass: 'iconfont icon-yxr-documentTree',
          commandName: 'storage',
          execute: () => {
            this.currentFieldMode = 'storage'
            this.getCurrentField()
          },
        },
        binding: {
          title: '自定义命令',
          text: '字段绑定',
          bigButton: 'true',
          iconClass: 'iconfont icon-bg-link',
          commandName: 'binding',
          execute: () => {
            this.getCurrentSelectedField()
          },
        },
        mode: {
          title: '自定义命令',
          text: '模式切换',
          bigButton: 'true',
          iconClass: 'iconfont icon-yxr-spaceExchange',
          commandName: 'mode',
          execute: () => {
            this.showModeDialog = true
          },
        },
      }
      if (this.$route.query.type !== 'view') {
        const customTab = {
          id: 'customTab',
          text: '模板配置',
          buttonGroups: [
            {
              commandGroup: {
                children: [
                  {
                    direction: 'horizontal',
                    commands: ['export', 'saveTemplate', 'storage', 'binding', 'mode'],
                  },
                ],
              },
            },
          ],
        }
        config.ribbon = _.uniqBy([...config.ribbon, customTab], 'id')
      } else {
        config.ribbon = _.uniqBy([...config.ribbon], 'id')
      }
      const designer = new GC.Spread.Sheets.Designer.Designer(
        document.getElementById('gc-designer-container-box'),
        config
      )
      this.designer = designer
      this.spread = designer.getWorkbook()
      this.excelIo = new GC.Spread.Excel.IO()
      this.sheet = this.spread.getActiveSheet()
      this.sheet
        .getRange(0, 0, this.sheet.getRowCount(), this.sheet.getColumnCount())
        .hAlign(GC.Spread.Sheets.HorizontalAlign.center)
      this.sheet
        .getRange(0, 0, this.sheet.getRowCount(), this.sheet.getColumnCount())
        .vAlign(GC.Spread.Sheets.VerticalAlign.center)
      this.sheet.options.allowUserResize = true
      this.sheet.options.protectionOptions = {
        allowResizeRows: true,
        allowResizeColumns: true,
      }

      this.spread.getHost().addEventListener('drop', (event) => {
        // 拖动监听
        const offset = $('#vp').offset()
        const x = event.pageX - offset.left
        const y = event.pageY - offset.top
        this.currentDropPosition = {
          row: this.spread.hitTest(x, y).worksheetHitInfo.row,
          col: this.spread.hitTest(x, y).worksheetHitInfo.col,
        }
      })

      if (!this.$route.query.templateId) {
        this.sheet.setColumnCount(100) // 设置列数
        this.sheet.setRowCount(50) // 设置列数
      }
      await this.setSheetData()
      this.setFieldTree()
      if (this.$route.query.type !== 'view') {
        GC.Spread.Sheets.Designer.getCommand('templateDesignMode').execute(this.designer, undefined)
      }
      if (this.$route.query.type === 'view') {
        this.spread.options.allowContextMenu = false
      }

      this.resetBindingPathFun()
      // const dragendResolve = () => {
      //   this.isGragEnd = true
      //   this.$nextTick(() => {
      //     this.isGragEnd = false
      //   })
      // }
      // window.addEventListener('dragend', dragendResolve.bind(this))
    },

    async setSheetData() {
      if (!this.$route.query.templateId) return
      this.spreadjsLoading = true
      const res = await StandardManagementService.getTemplateData({
        id: this.$route.query.templateId,
      })
      this.spreadjsLoading = false
      if (res && res.data?.context && res.code === 0) {
        const context = JSON.parse(res.data.context)
        const contextKeys = Object.keys(context.sheets)
        if (contextKeys.length) {
          // 之前有生成好的模板是禁用状态
          context.sheets[contextKeys[0]].isProtected = false
        }
        this.spread.fromJSON(context)
        if (this.$route.query.type === 'view') {
          const sheet = this.spread.getActiveSheet()
          sheet.options.isProtected = true // 禁止编辑
        }

        // 找出当前模板使用了哪些表，并将这些表排在字段列表前面
        const spreadJson = { ...context }
        const sheetsKeys = Object.keys(spreadJson.sheets)
        if (sheetsKeys.length) {
          const tables = spreadJson.sheets[sheetsKeys[0]].tables // 已存在的表格
          const tableNameList = _.map(tables, 'bindingPath')
          _.forEach(this.tableFieldList, (tableItem, index) => {
            if (tableNameList.includes(tableItem.className)) {
              const item = this.tableFieldList.splice(index, 1)[0]
              this.tableFieldList.unshift(item)
            }
          })
        }
      }
    },

    /**
     * @description 绑定字段列表
     */
    setFieldTree() {
      this.spreadjsLoading = true
      const treeData = {}
      const treeListData = _.cloneDeep(this.tableFieldList)
      _.forEach(treeListData, (i) => {
        i.type = 'table'
        i.dataFieldType = 'table'
        const { className } = i
        const properties = {}
        _.forEach(i.attributeList, (item) => {
          item.type = 'string'
          item.dataFieldType = 'text'
          const { attributeName, type, dataFieldType } = item
          properties[attributeName] = { type, dataFieldType }
        })
        treeData[className] = {
          properties,
          dataFieldType: 'table',
        }
      })
      this.designer.setData(
        'treeNodeFromJson',
        JSON.stringify({
          $schema: 'http://json-schema.org/draft-04/schema#',
          properties: treeData,
          type: 'string',
        })
      )
      this.designer.setData(
        'oldTreeNodeFromJson',
        JSON.stringify({
          $schema: 'http://json-schema.org/draft-04/schema#',
          properties: treeData,
          type: 'string',
        })
      )
      this.spreadjsLoading = false
    },

    down(blob) {
      const url = window.URL.createObjectURL(blob)
      // 创建隐藏的可下载链接
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.target = '_blank'
      link.setAttribute(
        'download',
        `${this.$route.query.className || ''}${dayjs().format('YYYY-MM-DD HH:mm:ss')}.xlsx`
      )
      document.body.appendChild(link)
      link.click()
    },

    /**
     * @description 返回列表页面
     */
    goBack() {
      this.$router.push({
        path: `${this.basePath}/legacy-resource/online-filling/entity-config`,
      })
    },
  },
}
</script>

<style lang="scss" scoped>

.spreadHost {
  width: 800px;
  height: 800px;
}
.designer {
  height: calc(100% - 15px);
}

#gc-designer-container-box {
  height: calc(100% - 33px);
}

.switch {
  position: fixed;
  display: inline-block;
  width: 50px;
  height: 20px;
  top: 5px;
  right: 40px;
}

.switchm {
  position: fixed;
  display: inline-block;
  width: 100px;
  height: 20px;
  top: 5px;
  right: 100px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.innerSlider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  height: 20px;
}

.innerSlider:before {
  position: absolute;
  content: '';
  height: 15px;
  width: 15px;
  left: 5px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .innerSlider {
  background-color: rgb(164, 60, 120);
}

input:focus + .innerSlider {
  box-shadow: 0 0 1px rgb(164, 60, 120);
}

input:checked + .innerSlider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
}

/* Rounded innerSliders */
.innerSlider.round {
  border-radius: 10px;
}

.innerSlider.round:before {
  border-radius: 50%;
}

.designer {
  height: calc(100% - 15px);
}
.gc-ribbon-bar .ribbon-button-item.ribbon-bigbutton .ribbon-button-item-icon {
  font-size: 25px !important;
}
.text-25px {
  font-size: 25px !important;
}
::v-deep .fileButton {
  display: none;
}

</style>
